module.exports = __webpack_public_path__ + "static/media/Linux_Kernels_In_The_Open.05648784.svg";